export const baseURL = "https://staging-ferrywheel.adminvergelive.com/"
export const adminBaseURL = "https://staging-admin.adminvergelive.com/"
export const key = "vlk_dc9021ebd49229a61d081f0d6368c81594336631f9fc031d"
